import restApi from "@plannel/services/utils/rest-api";

const getAll = (params) => {
  return restApi.post("/api/customers", params );
};

const getAllForCSV = params => {
  return restApi.post("/api/customers/csv", params );
};

const getLookup = () => {
  return restApi.get("/api/customers/lookup");
}

const get = id => {
  return restApi.get(`/api/customers/${id}`);
};

const getByPostn = (params) => {
  return restApi.get("/api/customers/postn", { params });
};

const getByHrchyCd = (params) => {
  return restApi.get("/api/customers/hrchy-code", { params });
};

const upsert = data => {
  return restApi.post("/api/customers/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/customers/${ids}`);
};

const search = params => {
  return restApi.get("/api/search/index/customer", { params })
}

const validateCodes = codes => {
  return restApi.post("/api/search/index/customer/validate", codes);
};

const customerService = {
  getAll,
  getAllForCSV,
  getLookup,
  get,
  getByPostn,
  getByHrchyCd,
  upsert,
  remove,
  search,
  validateCodes
};

export default customerService;